import MyLearn from '../views/myLearn/myLearn';
import MyLearnCenter from '../views/myLearn/myLearnCenter';
import SynchroWorkbook from '../views/myLearn/synchroWorkbook';
import MyLearnBeikao from '../views/myLearn/beikao';
import WorkbookDetails from '../views/myLearn/workBookDetails';
import PaperDetails from '../views/myLearn/paperDetails';
import PaperPreview from '../views/myLearn/paperPreview';
import WorkBookParse from '../views/myLearn/workBookParse';
import MyLearnBeikaoMingxiao from '../views/myLearn/beikao/mingxiao';
import MyLearnBeikaoJieduan from '../views/myLearn/beikao/jieduan';
import MyLearnBeikaoZhuanti from '../views/myLearn/beikao/zhuanti';
import {WebLayoutWithBack} from '../layout/WebLayout';

const xkwRoutes = [
  {
    name: 'MyLearn',
    component: MyLearn,
    options: {
      title: 'AI同步测',
    },
  },
  {
    name: 'MyLearnCenter',
    component: MyLearnCenter,
    options: {
      title: '我的学案',
    },
  },
  {
    // name: 'MyLearn',
    name: 'SynchroWorkbook',
    component: SynchroWorkbook,
    options: {
      title: 'AI同步测',
    },
  },
  {
    // name: 'MyLearn',
    name: 'MyLearnBeikao',
    component: MyLearnBeikao,
    options: {
      title: 'AI备考',
    },
  },
  {
    name: 'WorkbookDetails',
    component: WorkbookDetails,
    options: {
      title: '试题详情',
    },
  },
  {
    name: 'PaperDetails',
    component: PaperDetails,
    options: {
      title: '试卷详情',
    },
  },
  {
    name: 'PaperPreview',
    component: PaperPreview,
    options: {
      title: '试卷预览',
    },
  },
  {
    name: 'WorkBookParse',
    component: WorkBookParse,
    layout: WebLayoutWithBack,
    options: {
      title: '试题解析',
    },
  },
  {
    name: 'MyLearnBeikaoMingxiao',
    component: MyLearnBeikaoMingxiao,
    options: {
      title: '名校真题',
    },
  },
  {
    name: 'MyLearnBeikaoJieduan',
    component: MyLearnBeikaoJieduan,
    options: {
      title: '阶段测评',
    },
  },
  {
    name: 'MyLearnBeikaoZhuanti',
    component: MyLearnBeikaoZhuanti,
    options: {
      title: '专题训练',
    },
  },
].map(item => {
  item.layout = WebLayoutWithBack;
  return item;
});
export default xkwRoutes;
